export default "__VITE_ASSET__CTZUFAmU__"